import { type ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';
import { Utils } from 'app/main/components';
import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';

import OrdersListItem from '../OrdersListItem';
import OrdersShippingChargesTab from './tabs/OrdersShippingChargesTab';
import OrdersPromosTab from './tabs/OrdersPromosTab';
import OrdersStandardNotesTab from './tabs/OrdersStandardNotesTab';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => (
			<DetailsSectionWrapper disablePadding>
				<ViewList {...props} itemLayout={OrdersListItem} />
			</DetailsSectionWrapper>
		)
	},
	{
		id: 'shippingcharges',
		title: 'TAB_SHIPPINGCHARGES',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'orders-shippingcharges'),
		content: ({ refresh, updateRefresh }) => (
			<OrdersShippingChargesTab refresh={refresh} updateRefresh={updateRefresh} />
		)
	},
	{
		id: 'promos',
		title: 'TAB_PROMOS',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'orders-promos'),
		content: () => <OrdersPromosTab />
	},
	{
		id: 'standard-notes',
		title: 'TAB_STANDARDNOTES',
		hidden: ({ authorizer }) =>
			authorizer.cannot('view', 'orders-standardnotes') ||
			Utils.getConnectionFromToken() === 'PERCEPTIVE_CONTROL_BEB',
		content: () => <OrdersStandardNotesTab />
	}
];

export default tabs;
